import { render, staticRenderFns } from "./PresentationPackageDeleteElementsModal.vue?vue&type=template&id=20144fa0&scoped=true&"
import script from "./PresentationPackageDeleteElementsModal.vue?vue&type=script&lang=js&"
export * from "./PresentationPackageDeleteElementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20144fa0",
  null
  
)

export default component.exports